import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';
import { MultiSelect, MultiSelectChangeEvent } from 'primeng/multiselect';

@Component({
    selector: 'nx-edit-multiselect-input',
    template: `
    <div>
        <label for="multiSelect">{{label | translate}}<ng-container *ngIf=isRequired()>*</ng-container></label>
        <p-multiSelect
            #multiSelect
            id="multiSelect"
            optionLabel="name"
            [options]="_options" 
            [(ngModel)]="selected"
            (onChange)="onInputChange($event)" 
            [appendTo]="'body'"
            [selectedItemsLabel]="'{0} gewählt'"
            [maxSelectedLabels]="4"
            [panelStyleClass]="'nx-edit-dialog' + (panelWidhtFull ? ' full-width' : '')"
            [placeholder]="placeholder | translate" />
        <small *ngIf="helpText">{{helpText | translate}}</small>
    </div>
  `,
    styles: [`

  `],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditMultiSelectInputComponent),
            multi: true
        }
    ]
})
export class EditMultiSelectInputComponent implements ControlValueAccessor, OnInit, AfterViewInit {

    @ViewChild('multiSelect') multiSelect: MultiSelect;
    _options: any[];

    ngControl: NgControl;
    @Input() filter = false;
    @Input() panelWidhtFull = false;
    @Input() label: string;
    @Input() placeholder: string;
    @Input() helpText: string;
    @Input() set options(options :any[]){
        this._options = options;
        if(this.selectedIds){
            this.selected = this._options.filter(option => this.selectedIds.includes(option.id));
        }
    }
    @Input() optionLabel: string = 'name';

    selected: any[];
    selectedIds: string[];

    private onChange: (value: any[]) => void;
    private onTouched: () => void;

    constructor(
        private _injector: Injector,
        private cdr: ChangeDetectorRef
    ) {
    }
    ngAfterViewInit(): void {
        this.multiSelect.updateModel(this.selected);
        this.cdr.detectChanges();
    }

    ngOnInit() {
        this.ngControl = this._injector.get(NgControl);
        this.ngControl.valueAccessor = this;
    }

    writeValue(selected: any[]): void {
        this.selectedIds = selected;
        // convert the array of ids to an array of objects by using
        // the available options to feed this into the multiselect
        this.selected = this._options?.filter(option => selected?.includes(option.id));
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // Optional: Implementieren Sie die Logik zum Deaktivieren des Steuerelements
    }

    onInputChange(event: MultiSelectChangeEvent): void {
        console.log(event);
        this.selected = event.value;
        if (this.onChange) {
            // reduce the objects to an array of ids
            this.onChange(this.selected.map(option => option.id));
        }
    }

    onBlur(): void {
        if (this.onTouched) {
            this.onTouched();
        }
    }

    isRequired(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required);
    }

}